import {Component, input, model} from '@angular/core';
import {Button} from "primeng/button";
import {CreateTaStepContainerComponent} from "../create-ta-step-container/create-ta-step-container.component";
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {CreateTaStep} from '../../../../util/app.types';

@Component({
  selector: 'app-create-ta-step-modal',
  imports: [
      Button,
      CreateTaStepContainerComponent
  ],
  templateUrl: './create-ta-step-modal.component.html',
  styleUrl: './create-ta-step-modal.component.scss'
})
export class CreateTaStepModalComponent {
  currentStep = input<CreateTaStep>();
  isReadOnly = input<Boolean>();
  // Itinerary traveller, synced with the opener.
  travellerId = model<string>('');

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {}

  closeDialog(data: any): void {
    this.ref.close(data);
  }
}
